// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Rails from "@rails/ujs";
import I18n, { loadTranslations } from "@/i18n-js/instance";
import LocalTime from "local-time";
// eslint-disable-next-line no-restricted-imports -- global stylesheets must be bundled here
import "stylesheets/third_party.scss";
// eslint-disable-next-line no-restricted-imports -- global stylesheets must be bundled here
import "stylesheets/application.scss";
import "react_mount";
import "@/src/timezone";
import tippy from "tippy.js";

/* eslint-disable @typescript-eslint/no-require-imports -- Rails packages exported as CJS */
require("@rails/activestorage").start();
/* eslint-enable @typescript-eslint/no-require-imports -- end Rails CJS imports */

window.I18n = I18n;

loadTranslations();

LocalTime.start();

const initialiseTippy = (container = document) => {
  const tip = tippy(container.querySelectorAll("[data-tippy-content]"), {
    allowHTML: true,
  });

  // Disable tippy on mobile
  document.addEventListener("touchstart", function handler() {
    tip.forEach(instance => {
      instance.destroy();
    });
    document.removeEventListener("touchstart", handler);
  });
};
window.initialiseTippy = initialiseTippy;
document.addEventListener("DOMContentLoaded", () => {
  initialiseTippy();

  // Remove show_back_link param
  if (window.location.href.includes("show_back_link=true")) {
    window.history.replaceState(
      {},
      document.title,
      location.href.split("?")[0],
    );
  }

  // fix issue with navigation to an id/name.
  if (window.location.hash) {
    const tag = document.getElementById(window.location.hash.slice(1));
    if (tag) {
      tag.scrollIntoView(true);
    } else {
      const tags = document.getElementsByName(window.location.hash.slice(1));
      if (tags.length) {
        tags[0].scrollIntoView(true);
      }
    }
  }
});
// Run instagram/facebook embeds

window.webview = {
  // DEPRECATED: This is only used by the old webview
  isComingFromReactNativeWebview: false,
  isComingFromReactNativeAuthenticatedWebview: false,
  // use this one instead
  isInsideMobileWebview: false,
  electronAPI: {},
  // callback called on Live Stream 'Leave' button click, after api calls are done
  onLeaveLiveStream: null,
  // callback called on Live Stream 'Back to community' button click
  onEndLiveStream: null,
  ...window.webview,
};

Rails.start();
